<template>
    <v-container>
        <div class="headline" v-if="userData!=null">
            Willkommen {{userData.forename}}&nbsp;{{userData.lastname}}
        </div>
        <v-row class="mt-12 mb-12">
            <v-col cols="12" xs="12" sm="6" md="3" lg="3" v-for="module in myItems" :key="module.icon">
                <v-hover
                        v-slot:default="{ hover }"
                        open-delay="200"
                >
                    <v-card :elevation="hover ? 16 : 2" class="handpointer" @click="goToUrl(module.url)">
                        <v-col cols="4" class="text-center">
                            <v-card :color="module.color" width="80px" height="60px" class="pt-2 mt-n8" dark>
                                <v-icon x-large>{{module.icon}}</v-icon>
                            </v-card>
                        </v-col>
                        <v-col cols="12" class="pt-0 text-right">
                            <v-card-title class="font-weight-light title pb-0 pr-0">
                                <v-spacer></v-spacer>
                                {{module.title}}
                            </v-card-title>
                        </v-col>
                        <v-divider inset></v-divider>
                        <v-col colos="12" class="text-right pt-0">
                            <v-card-text class="title font-weight-bold pa-0">
                                <span :style="'color:'+ module.color">{{module.cnt}}</span>
                            </v-card-text>
                        </v-col>
                    </v-card>
                </v-hover>
            </v-col>
        </v-row>


        <!--<v-row class="mt-12 mb-12">
            <v-col cols="12" xs="12" sm="6" md="6" lg="6">
                <v-hover
                        v-slot:default="{ hover }"
                        open-delay="200"
                >
                    <v-card :elevation="hover ? 16 : 2" class="handpointer" height="500">
                        <v-row justify="center" class="hover05">
                            <div class="displayCard">
                            <figure>
                                <v-card width="330px" class="mt-n12 overButton">
                                    <v-img
                                            class="align-end"
                                            height="200px"
                                            src="/static/DER-hoch.jpg"
                                    >
                                        <div style="background-color: rgba(255,255,255, 0.8)">
                                            <v-card-title class="caption pb-1 pt-1"> {{titleGeraete}}
                                            </v-card-title>
                                        </div>
                                    </v-img>
                                </v-card>
                            </figure>
                            </div>
                        </v-row>
                        <v-row justify="center">
                            <v-btn class="ma-2 text-none" text color="success" small>
                                Eigenes Bild hochladen
                            </v-btn>
                        </v-row>
                        <v-row justify="space-around">
                            <v-card-title class="body-1 ml-2">
                                Playlist: {{playlistName}}
                            </v-card-title>
                            <v-card-title class="body-1 mr-2">
                                {{numberOfItemsCard}}
                            </v-card-title>
                        </v-row>
                        <v-sheet
                                class="mx-auto"
                                elevation="0"
                                max-width="800"
                        >
                            <v-slide-group
                                    v-model="model1"
                                    class="pa-4"
                                    show-arrows
                            >
                                <v-slide-item
                                        v-for="n in 15"
                                        :key="n"
                                >
                                    <v-card
                                            color="grey"
                                            class="ma-2"
                                            height="200"
                                            width="100"
                                            @click="openDialogHoch"
                                    >
                                        <v-row
                                                class="fill-height"
                                                align="center"
                                                justify="center"
                                        >
                                        </v-row>
                                    </v-card>
                                </v-slide-item>
                            </v-slide-group>
                        </v-sheet>
                    </v-card>
                </v-hover>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="6" lg="6">
                <v-hover
                        v-slot:default="{ hover }"
                        open-delay="200"
                >
                    <v-card :elevation="hover ? 16 : 2" class="handpointer" height="500">
                        <v-row justify="center" class="hover05">
                            <div class="displayCard">
                                <figure>
                                    <v-card width="330px" class="mt-n12 overButton">
                                        <v-img
                                                class="align-end"
                                                height="200px"
                                                src="/static/DER-quer.jpg"
                                        >
                                            <div style="background-color: rgba(255,255,255, 0.8)">
                                                <v-card-title class="caption pb-1 pt-1"> {{titleGeraete}}
                                                </v-card-title>
                                            </div>
                                        </v-img>
                                    </v-card>
                                </figure>
                            </div>
                        </v-row>
                        <v-row justify="center">
                            <v-btn class="ma-2 text-none" text color="success" small>
                                Eigenes Bild hochladen
                            </v-btn>
                        </v-row>
                        <v-row justify="space-around">
                            <v-card-title class="body-1 ml-2">
                                Playlist: {{playlistName}}
                            </v-card-title>
                            <v-card-title class="body-1 mr-2">
                                {{numberOfItemsCard}}
                            </v-card-title>
                        </v-row>
                        <v-sheet
                                class="mx-auto mt-5"
                                elevation="0"
                        >
                            <v-slide-group
                                    v-model="model1"
                                    class="pa-4"
                                    show-arrows
                            >
                                <v-slide-item
                                        v-for="n in 15"
                                        :key="n"
                                >
                                    <v-card
                                            color="grey"
                                            class="ma-2"
                                            height="150"
                                            width="230"
                                            @click="openDialog"
                                    >
                                        <v-row
                                                class="fill-height"
                                                align="center"
                                                justify="center"
                                        >
                                        </v-row>
                                    </v-card>
                                </v-slide-item>
                            </v-slide-group>
                        </v-sheet>
                    </v-card>
                </v-hover>
            </v-col>
        </v-row>-->
    </v-container>
</template>

<script>
    import Vue from 'vue'

    export default {
        name: "DashboardMain",
        components: {},
        data: () => ({
            numberOfItemsCard: '15 Items',
            titleGeraete: 'Mein Gerät ...',
            playlistName: 'Name der Playlist',
            model1: null,
            dialog: false,
            value: '',
            forename: '',
            lastname: '',
            drawer: null,
            userData: '',
            isShowMenu: false,
            model: '',
            ApplicationName: 'Kermax',
            showSearch: false,
            showNotify: false,
            showApps: false,
            companyId: null,
            items: [
                {
                    icon: 'keyboard_arrow_up',
                    'icon-alt': 'keyboard_arrow_down',
                    text: 'Navigation',
                    id: '1',
                    model: 'true',
                    children: []
                }
                /* ,
                {
                  icon: 'keyboard_arrow_up',
                  'icon-alt': 'keyboard_arrow_down',
                  text: 'Admin',
                  id: '2',
                  model: 'true',
                  children: [
                    {icon: 'supervisor_account', text: 'Benutzer', url: '/Dashboard/Benutzer'}
                  ],
                } */

            ],
            companyData: null,
            devices: null,
            modules: [
                {
                    color: '#fcbf00',
                    cnt: '0',
                    visible: false,
                    title: 'Netzwerke',
                    icon: 'business'
                },
                {
                    color: '#fcbf00',
                    cnt: '-',
                    visible: false,
                    title: 'Mein Standort',
                    url: '/Dashboard/MainLocation',
                    icon: 'house'
                },
                {
                    color: '#1B5E20',
                    cnt: '0',
                    visible: false,
                    title: 'Playlist',
                    icon: 'play_circle_outline'
                },
                {
                    color: '#E65100',
                    cnt: '0',
                    visible: false,
                    url: '/Dashboard/MainDevices',
                    title: 'Meine Geräte',
                    icon: 'devices'
                },
                {
                    color: '#26C6DA',
                    cnt: '0',
                    visible: false,
                    title: 'Benutzer',
                    icon: 'people'
                }
            ]
        }),
        computed: {
            myItems () {
                var cmp = this
                return cmp.modules.filter(item => {
                    return item.visible
                })
            }
        },
        methods: {
            goToUrl: function (url) {
                this.$router.push(url)
            },
            openDialog: function () {
                this.$refs.dlgVideo.open()
            },
            openDialogHoch: function () {
                this.$refs.dlgVideoHoch.open()
            },
            openItem: function (item) {
                console.log('open item', item)
                this.$router.push(item.url)
            },
            open: function () {
            },
            goToNetzwerke: function () {
                this.$router.push('/Dashboard/Netzwerke')
            },
            goToPlaylist: function () {
                this.$router.push('/Dashboard/Playlist')
            },
            goToGeraete: function () {
                this.$router.push('/Dashboard/Geraete')
            },
            goToBenutzer: function () {
                this.$router.push('/Dashboard/Benutzer')
            },
            onGetDevices: function (data) {
                this.devices = data
                this.modules[3].cnt = data.length
            },
            onGetData: function (data) {
              if (data.length > 0 ) {
                this.companyData = data[0]
                this.modules[1].cnt = this.companyData.postcode + ' ' + this.companyData.city
                Vue.prototype.$api.loadDevicesFromCompany(this.companyId, this.onGetDevices)
              }
            },
            reload: function () {
                var reqData = {
                    isMother: 1
                }
                reqData.guid = Vue.prototype.$api.getCredentials().data.guidParent

                Vue.prototype.$apiCompany.loadCompanies(reqData, this.onGetData)
            }
        },
        mounted() {
            if (Vue.prototype.$apiRight.hasRight('DASHBOARD_VISIBLE_NETWORK')) {
                this.modules[0].visible = true
            }
            this.modules[1].visible = true
            if (Vue.prototype.$apiRight.hasRight('DASHBOARD_VISIBLE_PLAYLIST')) {
                this.modules[2].visible = true
            }
            if (Vue.prototype.$apiRight.hasRight('DASHBOARD_VISIBLE_DEVICES')) {
                this.modules[3].visible = true
            }
            if (Vue.prototype.$apiRight.hasRight('DASHBOARD_VISIBLE_USER')) {
                this.modules[4].visible = true
            }

            this.isShowMenu = true
            this.userData = Vue.prototype.$api.getCredentials().data
            this.companyId = Vue.prototype.$api.getCredentials().data.guidParent
            this.reload()

        }
    }
</script>

<style scoped>

</style>
